import React from 'react';
import { Section } from './ui/Section';
import { Wrench, Smartphone, ShieldCheck } from 'lucide-react';
export function Mechanism() {
  return <Section bg="bg-brand-cream" data-id="element-93">
      <div className="text-center mb-12" data-id="element-94">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-brown mb-4" data-id="element-95">
          El Triángulo de la Alfabetización Productiva
        </h2>
        <p className="text-lg md:text-xl text-brand-brown-light max-w-2xl mx-auto" data-id="element-96">
          Este método no te enseña a ser un gurú digital. Te enseña a conectar
          tres puntos que ya tienes:
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-6" data-id="element-97">
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-brand-sand text-center" data-id="element-98">
          <div className="bg-brand-sand w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-99">
            <Wrench className="w-8 h-8 text-brand-terracotta" data-id="element-100" />
          </div>
          <h3 className="text-xl font-bold mb-3 text-brand-brown" data-id="element-101">
            Tu Habilidad
          </h3>
          <p className="text-brand-brown-light text-lg" data-id="element-102">
            Lo que ya sabes hacer (cocina, mantenimiento, trámites, cuidado).
          </p>
        </div>

        <div className="bg-white p-6 rounded-2xl shadow-sm border border-brand-sand text-center" data-id="element-103">
          <div className="bg-brand-sand w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-104">
            <Smartphone className="w-8 h-8 text-brand-terracotta" data-id="element-105" />
          </div>
          <h3 className="text-xl font-bold mb-3 text-brand-brown" data-id="element-106">
            Tu Conector
          </h3>
          <p className="text-brand-brown-light text-lg" data-id="element-107">
            Aprender a usar WhatsApp y Facebook Marketplace de forma
            profesional.
          </p>
        </div>

        <div className="bg-white p-6 rounded-2xl shadow-sm border border-brand-sand text-center" data-id="element-108">
          <div className="bg-brand-sand w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-109">
            <ShieldCheck className="w-8 h-8 text-brand-terracotta" data-id="element-110" />
          </div>
          <h3 className="text-xl font-bold mb-3 text-brand-brown" data-id="element-111">
            Tu Seguridad
          </h3>
          <p className="text-brand-brown-light text-lg" data-id="element-112">
            Implementar el cobro digital blindado para que el dinero llegue a tu
            banco sin riesgos.
          </p>
        </div>
      </div>

      <div className="mt-10 text-center bg-brand-green/10 p-6 rounded-2xl" data-id="element-113">
        <p className="text-xl md:text-2xl font-semibold text-brand-green-dark" data-id="element-114">
          Es el puente entre el mundo que conoces y la tecnología que necesitas
          para facturar.
        </p>
      </div>
    </Section>;
}